import axios from "../api/axios";

export interface CDTCode {
  id: number;
  code: string;
  description: string;
  laymanExplanation: string;
  category: string;
  defaultFee: number;
  defaultDurationMinutes: number;
  isActive: boolean;
  needsTooth?: boolean;
  needsSurface?: boolean;
  needsRange?: boolean;
  treatArea?: number;
}

export interface GetCDTCodesParams {
  search?: string;
  category?: string;
  activeOnly?: boolean;
}

export const cdtCodesService = {
  async getCDTCodes(params?: GetCDTCodesParams): Promise<CDTCode[]> {
    const queryParams = new URLSearchParams();

    if (params?.search) {
      queryParams.append("search", params.search);
    }
    if (params?.category) {
      queryParams.append("category", params.category);
    }
    if (params?.activeOnly !== undefined) {
      queryParams.append("activeOnly", params.activeOnly.toString());
    }

    const queryString = queryParams.toString();
    const url = `/cdt-codes${queryString ? `?${queryString}` : ""}`;

    const response = await axios.get<CDTCode[]>(url);
    return response.data || [];
  },
};
